import React from "react";

interface HeaderWorkOrderProps {
  current: number;
}

const Header_WorkOrder: React.FC<HeaderWorkOrderProps> = ({ current }) => {
  return (
    <div id="workOrderForms" className="steps clearfix">
      <ul>
        <li className={current >= 1 ? "first done" : "first"}>
          <a href="#wizard-01-h-0" onClick={(ev) => ev.preventDefault()}>
            {/* <span className="step-number">01</span> */}
            <h5>General Information</h5>
            {/* <span className="step-text">
              Contract details, site selection, and basic information
            </span> */}
          </a>
        </li>
        <li className={current >= 2 ? "done" : ""}>
          <a href="#wizard-01-h-1" onClick={(ev) => ev.preventDefault()}>
            {/* <span className="step-number">02</span> */}
            <h5>Work Order Details</h5>
            {/* <span className="step-text">
              Work lines and task selection
            </span> */}
          </a>
        </li>
        <li className={current >= 3 ? "done" : ""}>
          <a href="#wizard-01-h-2" onClick={(ev) => ev.preventDefault()}>
            {/* <span className="step-number">03</span> */}
            <h5>General Conditions</h5>
            {/* <span className="step-text">
              Contract terms and conditions
            </span> */}
          </a>
        </li>
        <li className={current >= 4 ? "done" : ""}>
          <a href="#wizard-01-h-3" onClick={(ev) => ev.preventDefault()}>
            {/* <span className="step-number">04</span> */}
            <h5>Payment Conditions</h5>
            {/* <span className="step-text">
              Payment terms and financial conditions
            </span> */}
          </a>
        </li>
        <li className={current === 5 ? "last done" : "last"}>
          <a href="#wizard-01-h-4" onClick={(ev) => ev.preventDefault()}>
            {/* <span className="step-number">05</span> */}
            <h5>Preview & Submit</h5>
            {/* <span className="step-text">
              Review all details and submit work order
            </span> */}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Header_WorkOrder;
